import { CIcon } from '~/icons/types'

export const ciWantedProperty: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'm22.45 17.3-3.337-6.261a.935.935 0 0 0-.756-.5.925.925 0 0 0-.825.369c-1.762 2.313-2.753 3.45-7.784 6.16h-.006l-.31.173a2.61 2.61 0 0 0-1.071 3.538.487.487 0 0 0 .046.069 2.638 2.638 0 0 0 3.52 1l.312-.173a62.57 62.57 0 0 1 1.42-.743l.089.166a2.625 2.625 0 0 0 3.541 1.079.499.499 0 1 0-.469-.882 1.625 1.625 0 0 1-2.191-.67l-.073-.136a15.357 15.357 0 0 1 7.122-1.814.945.945 0 0 0 .881-.927.935.935 0 0 0-.109-.447Zm-10.691 3.51-.31.172a1.631 1.631 0 0 1-2.2-.667.423.423 0 0 0-.036-.057 1.609 1.609 0 0 1 .7-2.13l.315-.175c.513-.276.975-.533 1.412-.781l1.55 2.892c-.451.227-.919.47-1.431.746Zm2.325-1.19L12.5 16.67a15.446 15.446 0 0 0 5.727-5.16l3.386 6.179c-2.628.03-5.21.693-7.529 1.932Zm-2.554-5.574v-2.845a2.3 2.3 0 0 0-2-2.2 2.3 2.3 0 0 0-2 2.2v2.38l-2.378.02V6.5c0-.012 0-.021-.006-.033L9.251 2.6a.383.383 0 0 1 .525 0l4.106 3.863c0 .012-.007.02-.007.033V11a.5.5 0 1 0 1 0V7.4l1.81 1.7a.5.5 0 1 0 .685-.728l-6.908-6.5a1.387 1.387 0 0 0-1.9 0l-6.908 6.5a.5.5 0 0 0 .686.728l1.812-1.7v6.2a.943.943 0 0 0 .942.941h5.936a.5.5 0 0 0 .5-.495Zm-3-2.845c0-.442.494-1.2 1-1.2s1 .758 1 1.2v2.35l-2 .02V11.2Z',
      fill: 'currentColor'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'wanted-property',
  type: 'thin'
}
